import { withDataConverter } from '@beef/react';
import { compose } from '@beef/utils';
import { withOnScreenAnalytics } from "../../../../../../../utils/withOnScreenAnalytics";
import { getWindow } from "../../../../../../../utils/window";
import { ymPushParams, ymReachGoal } from "../../../../../../../utils/ym.alternative";
import { State } from "../../../../../../dependencies/getState/State";
import { getAccountType } from "../../../../../../../utils/analytics";
import { ModalResult } from "./ModalResult";
import { converter } from "./converter";
import { getOnScreenAnalyticsHandler } from "./analytics";
export var RequestStatusRedesign = compose(withDataConverter(converter), withOnScreenAnalytics(getOnScreenAnalyticsHandler({
  // NOTE: Так как это общий компонент, нужно придумать способ получать тип аккаунта
  // Один из вариантов - session storage
  getAccountType: getAccountType,
  getWindow: getWindow,
  ymReachGoal: ymReachGoal,
  getState: function getState() {
    return State.getInstance().getData();
  },
  ymPushParams: ymPushParams
}), {
  shouldTriggerOnce: true,
  debounce: 100
}))(ModalResult);